<mat-toolbar class="custom-toolbar">
    <button mat-icon-button class="white-icon" aria-label="back clicked" (click)="backClicked()">
      <mat-icon class="volume-icon">arrow_back</mat-icon>
    </button>
    <span class="toolbar-title">Settings</span>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button class="white-icon" aria-label="read text" (click)="volumeClicked()">
      <mat-icon>volume_up</mat-icon>
    </button>
  </mat-toolbar>